import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type IconProps = {
	name: string;
	isFlipped?: boolean;
	rotates?: boolean;
	className?: string;
	onClick?: (e: React.SyntheticEvent) => void;
}
export default ({name, isFlipped, rotates, className, onClick}: IconProps) => (
	<div
		onClick={onClick}
		className={classNames(
			styles.icon,
			isFlipped && styles.isFlipped,
			rotates && styles.rotates,
			onClick && styles.hasCursor,
			className
		)}
	>
		<i className={classNames(
			'fa',
			`fa-${name}`,
			styles.content
		)}></i>
	</div>
);
